import { Network } from '@injectivelabs/networks'

export const injectivePeggyAddress = {
  [Network.Mainnet]: '0xF955C57f9EA9Dc8781965FEaE0b6A2acE2BAD6f3',
  [Network.MainnetK8s]: '0xF955C57f9EA9Dc8781965FEaE0b6A2acE2BAD6f3',
  [Network.MainnetLB]: '0xF955C57f9EA9Dc8781965FEaE0b6A2acE2BAD6f3',
  [Network.MainnetSentry]: '0xF955C57f9EA9Dc8781965FEaE0b6A2acE2BAD6f3',
  [Network.MainnetOld]: '0xF955C57f9EA9Dc8781965FEaE0b6A2acE2BAD6f3',
  [Network.Staging]: '0xF955C57f9EA9Dc8781965FEaE0b6A2acE2BAD6f3',
  [Network.Internal]: '0xF955C57f9EA9Dc8781965FEaE0b6A2acE2BAD6f3',
  [Network.Testnet]: '0x12e1181a741b70BE6A9D81f85af3E92B6ba41897',
  [Network.TestnetK8s]: '0x12e1181a741b70BE6A9D81f85af3E92B6ba41897',
  [Network.TestnetSentry]: '0x12e1181a741b70BE6A9D81f85af3E92B6ba41897',
  [Network.TestnetOld]: '0x12e1181a741b70BE6A9D81f85af3E92B6ba41897',
  [Network.Devnet]: '0x430544ca09F7914077a0E8F405Da62292428F49D',
  [Network.Devnet1]: '0x0AAd19327a1b90DDE4e2D12FB99Ab8ee7E4E528D',
  [Network.Devnet2]: '0x0AAd19327a1b90DDE4e2D12FB99Ab8ee7E4E528D',
  [Network.Devnet3]: '0x0AAd19327a1b90DDE4e2D12FB99Ab8ee7E4E528D',
  [Network.Local]: '0x3c92F7779A7845d5eEf307aEF39066Ddba04A54b'
}
